import React from 'react';
import FBCheckDeatils from '@components/Fireboard/components/Body/CheckDetails';
import SideDrawer from '@components/Fireboard/components/SideDrawer/index';

const CheckDetails = props => {
  const {
    selectedCheck,
    onCloseCheckDetails,
    checksRowData,
    showCheckDetails,
    currentView,
    currency,
  } = props;
  return (
    <SideDrawer
      isOpen={showCheckDetails}
      onRequestClose={onCloseCheckDetails}
      from="right"
      width="35%"
      height="100%"
      top="0"
    >
      <FBCheckDeatils
        selectedCheck={selectedCheck}
        checksRowData={checksRowData}
        currentView={currentView}
        currency={currency}
        {...props}
      />
    </SideDrawer>
  );
};

export default CheckDetails;
